'use strict';

var util = angular.module('gymsystem.util');

util.directive('lastentry', ['$rootScope', '$q', '$location', 'live', 'util', 'server', 'cashiers', 'EntryService', function($rootScope, $q, $location, live, util, server, cashiers, EntryService) {
    return {
        restrict: 'E',
        templateUrl: 'components/widgets/lastentry/lastentry.html',
        scope: {
            settings: '='
        },
        link: function($scope) {

            $scope.gotoCustomer = $rootScope.gotoCustomer;
            $scope.showWorkout = $rootScope.showWorkout;
            $scope.showRBooking = $rootScope.showRBooking;
            $scope.hasPermission = $rootScope.hasPermission;

            $scope.currentEntry = 0;
            $scope.trainingcards = [];
            $scope.wbookings = [];
            $scope.rbookings = [];
            $scope.bookings = []; // Collection of workoutbookings / resourcebookings

            $scope.unpaid = [];
            $scope.previousEntries = [];

            $scope.getAlertClass = function() {
                var entry = $scope.getCurrentEntry();
                if (!entry) { return ''; }
                return entry.success ? 'alert alert-success' : 'alert alert-danger';
            };

            $scope.formatValidTo = function(card) {
                var validTo = card.validToDate ? card.validToDate.yyyymmdd() : util.t('ongoing');
                var trainingsLeft = '';
                if (_.isNumber(card.trainingsLeft)) {
                    trainingsLeft = ' (' + card.trainingsLeft + ' ' + util.t('trainings left') + ')';
                }
                return validTo + trainingsLeft;
            };

            $scope.getFieldName = function(field) {
                var userfield = _.findWhere($rootScope.fields.user, { name: field });
                return util.t(userfield.title);
            };

            $scope.getFieldValue = function(field) {
                var entry = $scope.getCurrentEntry();
                if (!entry) { return ''; }
                var userfield = _.findWhere($rootScope.fields.user, { name: field });
                return userfield.builtIn ? entry.Member[userfield.name] : entry.Member.xf[userfield.name];
            };

            $scope.updateBookings = function() {
                var bookings = $scope.wbookings.map(function(wb) { return { type: 'wb', start: wb.startTime, data: wb }; });
                bookings = bookings.concat($scope.rbookings.map(function(rb) { return { type: 'rb', start: rb.time, data: rb }; }));
                var today = Date.today().getTime();
                bookings = bookings.filter(function(b) { return b.start.getTime() >= today; });
                $scope.bookings = bookings;
            };

            $scope.gotoCheckout = function() {
                var payments = $scope.unpaid.length ? $scope.unpaid : null;
                var customer = $scope.getCurrentEntry().Member;
                cashiers.transfer({customer: customer, payments: payments });
                var params = [];
                if (customer && customer.id) params.push('customer_id=' + customer.id);
                if (payments && payments.length) {
                    var ids = payments.map(function(p) { return p.id; }).filter(function(id) { return id != null; });
                    if (ids.length) params.push('payment_ids=' + ids.join(','));
                }
                $location.url('/checkout' + (params.length ? '?' + params.join('&') : ''));
            };

            $scope.originalImageSrc = function(size) {
                return $rootScope.memberImage($scope.getCurrentEntry().Member, size);
            };

            var getTrainingCards = function() {

                var isProduct = function(card) {
                    if (card.cardtype_id) {
                        var product = $rootScope.getPointerById(card.cardtype_id, $rootScope.trainingcardtypes);
                        if (product) {
                            return $rootScope.isProduct(product);
                        }
                    }
                };

                var itemFilter = function(card) {
                    return !isProduct(card) && card.type != 'course' && (card.trainingsLeft == null || card.trainingsLeft > 0) && (card.validToDate == null || card.validToDate >= Date.today()) && (card.validFromDate.isPastDate(true));
                };

                server.get('/api/trainingcard/get/all', { member_id: $scope.getCurrentEntry().Member.id }).then(function(trainingcards) {
                    $rootScope.waitFor(['trainingcardtypes']).then(function() {
                        angular.forEach(trainingcards, function(trainingcard) {
                            $rootScope.transformTrainingCard(trainingcard);
                        });
                        $scope.trainingcards = _.filter(trainingcards, itemFilter);
                    });
                });

            };

            var getWorkoutBookings = function() {
                if (!$rootScope.hasModule('WorkoutBooking')) { return; }
                server.get('/api/workoutBooking/getForMember', { member: $scope.getCurrentEntry().Member.id }).then(function(workouts) {
                    workouts.forEach($rootScope.transformWorkout);
                    $scope.wbookings = workouts;
                    $scope.updateBookings();
                });
            };

            var getResourceBookings = function() {
                if (!$rootScope.hasModule('ResourceBooking')) { return; }
                server.get('/api/member/resourcebooking/get', { member: $scope.getCurrentEntry().Member.id }).then(function(rbookings) {
                    $rootScope.transformResourceBookings(rbookings);
                    $scope.rbookings = rbookings.filter(function(rb) { return rb.siblings[0] == rb; });
                    $scope.updateBookings();
                });
            };


            var getPayments = function() {
                server.get('/api/payment/unpaid/get', { payer: $scope.getCurrentEntry().Member.id }).then(function(payments) {
                    payments.forEach($rootScope.transformPayment);
                    $scope.unpaid = payments;
                });
            };

            var getPreviousEntries = function() {
                var entry = $scope.getCurrentEntry();
                var now = new Date();
                var args = {
                    member: entry.Member.id.toString(),
                    fromDate: now.clone().addDays(-7).dateTime(),
                    toDate: now.dateTime(),
                    limit: 5,
                    idOnly: true
                };
                server.get('/api/entry/get', args).then(function(entries) {
                    entries.forEach($rootScope.transformEntry);
                    $scope.previousEntries = entries.filter(function(e) { return e.entryTime != entry.entryTime; });
                });
            };

            var reload = function() {
                if (!$scope.getCurrentEntry()) { return; }
                getTrainingCards();
                getWorkoutBookings();
                getResourceBookings();
                getPayments();
                getPreviousEntries();
            };

            function getEntries() {
                const filtered = $rootScope.entries.filter(entry => !$scope.settings.resource.length || $scope.settings.resource.includes(entry.door?.id));
                const sorted = filtered.sort((a, b) => a.entryTime < b.entryTime ? 1 : -1);
                return sorted;
            }

            $scope.getCurrentEntry = function() {
                if (!$scope.entries) { return null; }
                return $scope.entries[$scope.currentEntry];
            };

            $scope.historyBack = function() {
                $scope.currentEntry = Math.min($scope.currentEntry+1, $scope.entries.length-1);
                reload();
            };

            $scope.historyForward = function() {
                $scope.currentEntry = Math.max($scope.currentEntry-1, 0);
                reload();
            };

            $scope.historyEnd = function() {
                $scope.currentEntry = 0;
                reload();
            };

            $scope.registerCard = function() {
                var entry = $scope.getCurrentEntry();
                EntryService.entyCardDialog(entry.Member).then(function(result) {
                    if (result.remove) {
                        server.post('/api/card/remove', null, {user_id: entry.Member.id}, '{0} was removed', 'Failed to remove {0}', 'Card');
                    } else {
                        server.post(
                            '/api/card/set', null,
                            {
                                user_id: entry.Member.id,
                                cardId: result.value,
                                pin:    result.pin,
                                manual: result.manual
                            },
                            'Card/tag registered', 'Failed to register card/tag'
                            );
                    }
                });
            };

            function updateEntries() {
                const currentEntry = $scope.getCurrentEntry();
                const preserveCurrentEntry = $scope.currentEntry > 0 && currentEntry;
                $scope.entries = getEntries();
                if (preserveCurrentEntry) {
                    $scope.currentEntry = $scope.entries.findIndex(entry => entry.id == currentEntry.id);
                    if ($scope.currentEntry == -1) {
                        $scope.currentEntry = 0;
                    }
                }
                reload();
            }

            live.subscribe({
                type: 'entry',
                scope: $scope,
                callback: () => {
                    setTimeout(() => {
                        updateEntries();
                    }, 0); // The timeout is required since $rootScope.entries is updated in the same digest cycle
                }
            });

            $rootScope.waitFor(['entries']).then(updateEntries);
        }
    };
}]);
